import { useApolloClient } from '@apollo/client';
import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FeedbackPage, FeedbackPageParams } from './FeedbackPage';
import { createTelemetry } from './pageOutcomeMetric';
import { resolveMerlinContext } from './resolveContextClient';

/**
 * Wires the Feedback_Page's dependencies at the route boundary.
 *
 * `FeedbackPage` takes its Apollo client, context transport and telemetry as props so it can be rendered
 * in a test without a provider tree, a network stack or a metrics backend. This is the one place that
 * supplies the real ones, which keeps that testability from costing the route anything.
 */
export const MerlinFeedbackRoute: React.FC<
  RouteComponentProps<FeedbackPageParams>
> = (routerProps) => {
  const client = useApolloClient();

  // `logPath` gives the server the identifying values for a log record without any of them becoming a
  // metric dimension (Requirement 18 criterion 12d).
  const telemetry = useMemo(
    () => createTelemetry(routerProps.location.pathname),
    [routerProps.location.pathname]
  );

  return (
    <FeedbackPage
      {...routerProps}
      client={client}
      resolveContext={resolveMerlinContext}
      telemetry={telemetry}
    />
  );
};
